import { AiComponentsTabAgentAiDiscoveryDrawer } from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/components/AiComponentsTabAgentAiDiscoveryDrawer"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

// The components tab of a workflow: the same tab as an agent's, over its steps
export const AiComponentsTabWorkflowAiDiscoveryDrawer = (
  props: TabComponentProps
) => <AiComponentsTabAgentAiDiscoveryDrawer {...props} entityType="workflow" />
